import { type FilterProperty } from '@/types/advanceFilter';

import { defaultOperatorFor } from './OperatorSelect';

/**
 * A condition matching `values` on `property`, with the operator taken from the
 * property's relation rather than named by the caller. An operator the
 * property's filter schema leaves out is dropped when the query is serialized,
 * so the request carries no condition at all while the chip reads as applied.
 */
export const createConditionFor = (
  property: FilterProperty,
  values: string[]
) => ({
  property: property.name,
  operator: defaultOperatorFor(property),
  value: values,
});

/**
 * A condition for `property` with no values yet — the shape a freshly added
 * filter chip or condition row starts from. The operator is the first one the
 * property's relation allows, matching what OperatorSelect preselects.
 */
export const createEmptyCondition = (
  property: FilterProperty,
  value?: string
) => createConditionFor(property, value ? [value] : []);
